module.exports = __webpack_public_path__ + "static/media/expo.b3f4b653.webp";